<template lang="pug">
f7-page#coach-detail
  navbar

  //- bottom tool bar
  f7-toolbar(:bottom-md="true" class="apply-contract")
    coach-query(:coachId="coachId")
      template(slot-scope="{ coach }")
        large-button.apply-contract-button(
          title="この先生に申し込む"
          @click="showSignUp(coach)")

  coach-query(:coachId="coachId")
    div(slot-scope="{ coach }")
      //- page content
      coach-detail-top(:coach="coach")

      coach-detail-body(:coach="coach" class="coach-detail-body")
</template>

<style lang="scss" scoped>
.apply-contract {
  height: 80px !important;
  background: none;

  .apply-contract-button {
    margin: 24px !important;
    width: 100%;
  }
}

.coachButton {
  margin-left: 24px;
  margin-right: 24px;
}

.coach-detail-body {
  margin-bottom: 40px !important;
  position: absolute;
  top: 460px;
  width: 100%;
}
</style>

<script>
import Navbar from '@/components/organisms/TransparentNavbar'
import CoachDetailTop from '@/components/organisms/CoachDetailTop'
import CoachDetailBody from '@/components/organisms/CoachDetailBody'
import LargeButton from '@/components/atoms/LargeButton'
import CoachQuery from '@/components/queries/CoachQuery'

export default {
  components: {
    Navbar,
    CoachDetailTop,
    CoachDetailBody,
    LargeButton,
    CoachQuery,
  },
  data() {
    return {
      coachId: null,
    }
  },
  methods: {
    showSignUp(coach) {
      open(
        'https://docs.google.com/forms/d/e/1FAIpQLSdex9VjcUHX-pXO3VeyZpB2dS4Gdp0LG1JwBoKgsmMbl7DEhQ/viewform?usp=pp_url&entry.1944445344=' +
          coach.name,
        '_blank'
      )
    },
  },
  created() {
    this.coachId = this.$f7route.params.id
  },
}
</script>
